<button
	mat-icon-button
	class="palette-trigger"
	type="button"
	(click)="toggle()"
	matTooltip="Search (Ctrl+K)"
	aria-label="Search"
>
	<mat-icon>search</mat-icon>
</button>

<ng-template #palette>
	<div class="palette">
		<mat-form-field appearance="outline" class="palette-search" subscriptSizing="dynamic">
			<mat-icon matPrefix>search</mat-icon>
			<input
				matInput
				type="search"
				placeholder="Search organizations and pages"
				[ngModel]="term()"
				(ngModelChange)="term.set($event)"
			/>
		</mat-form-field>

		@if (results().length === 0) {
			<p class="no-results">Nothing matches “{{ term() }}”.</p>
		} @else {
			<ul class="results">
				@for (command of results(); track command.group + command.label) {
					<li>
						<button type="button" (click)="run(command)">
							<mat-icon>{{ command.icon }}</mat-icon>
							<span class="label">{{ command.label }}</span>
							<span class="group">{{ command.group }}</span>
						</button>
					</li>
				}
			</ul>
		}
	</div>
</ng-template>
